export function shouldRenderSliderArrows(container: HTMLElement | null) {
  if (!container) {
    return false;
  }

  return container.scrollWidth > container.offsetWidth;
}
